let language = {
    ADD_ADDRESS_FORM_ADD_TEXT: "Add Address",
    ADD_ADDRESS_FORM_EDIT_TEXT: "Edit",
};

export { language }